import { Box, Button } from '@mui/material';
// components
import { AccessDeniedIcon } from 'assets/svgs';
// constants, styles
import { PlainLayout } from 'components/common/PlainLayout';
import {
  LOG_OUT_BUTTON_TEXT,
  SUBSCRIPTION_EXPIRED_MSG_TEXT,
  SUBSCRIPTION_EXPIRED_TEXT,
} from 'constants/index';
import { handleLogout } from 'lib/helper';
import { textTransform } from 'styles/commonComponentStyle';

const SubscriptionExpired = () => (
  <PlainLayout title={SUBSCRIPTION_EXPIRED_TEXT} subTitle={SUBSCRIPTION_EXPIRED_MSG_TEXT} maxWidth="600px">
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mt={5} mb={8}>
        <AccessDeniedIcon />
      </Box>

      <Button variant="contained" sx={textTransform} onClick={() => handleLogout()}>
        {LOG_OUT_BUTTON_TEXT}
      </Button>
    </Box>
  </PlainLayout>
);

export default SubscriptionExpired;
